import {gql} from '@apollo/client';

export const UpdateRoleMutation = gql`
    mutation UpdateRole($relationId: RelationId!, $role: RoleUpdateType) {
        childContacts {
            updateRole(relationId: $relationId, role: $role) {
                relationId
                roleInvitations {
                    roleInvitationId
                    roleId
                    roleTitle
                    verification {
                        verificationMethod
                    }
                }
                roles {
                    role {
                        roleId
                        title
                    }
                    targetId
                }
            }
        }
    }
`;
